import * as React from "react";
import { ContainerQuery } from "react-container-query";
import { ui } from "../../../../dependencies";
import { marketColumnsDisplay, marketColumnsDisplayMultiview } from "../../../../constants";
import { CardType } from "../../../../data";
import { HeadingNamesWrap } from "../HeadingNamesWrap";
export const CustomHeading = (props) => {
    const columnsDisplay = props.cardType === CardType.Multiview
        ? marketColumnsDisplayMultiview
        : marketColumnsDisplay;
    return React.createElement(ContainerQuery, { query: columnsDisplay }, params => {
        return (React.createElement(ui.SubHeading, null,
            React.createElement("div", { className: `rj-sub-heading-inner rj-sub-heading-inner--${props.cardType.toLowerCase()}` },
                React.createElement(ui.HeadingTitle, { name: "", count: "" }),
                React.createElement(HeadingNamesWrap, { marketNames: props.marketNames, marketTemplates: props.marketTemplates, queryParams: params }))));
    });
};
//# sourceMappingURL=CustomHeading.js.map